import { render } from "./CreateGroupPermission.vue?vue&type=template&id=1144e2c5&scoped=true&ts=true"
import script from "./CreateGroupPermission.vue?vue&type=script&lang=ts"
export * from "./CreateGroupPermission.vue?vue&type=script&lang=ts"

import "./CreateGroupPermission.vue?vue&type=style&index=0&id=1144e2c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1144e2c5"]])

export default __exports__